import React, { FC, PropsWithChildren, ReactElement, ReactNode, useEffect, useState } from 'react';
import { useRouter } from 'next/router';

export interface IAlert {
  title?: string;
  message?: ReactNode;
  actions?: ReactNode;
  error?: boolean;
  info?: boolean;
}

interface AlertContextType {
  alerts: IAlert[];
  setAlerts: (alerts: IAlert[]) => void;
}

export const AlertContext = React.createContext<AlertContextType>({
  alerts: [],
  setAlerts: () => undefined
});

const AlertProvider: FC<PropsWithChildren> = ({ children }): ReactElement => {
  const [alerts, setAlerts] = useState<IAlert[]>([]);
  const router = useRouter();

  useEffect(() => {
    const clear = () => setAlerts([]);
    router.events.on('routeChangeStart', clear);
    return () => router.events.off('routeChangeStart', clear);
  }, [router.events]);

  const contextValue = {
    alerts,
    setAlerts
  };

  return <AlertContext.Provider value={contextValue}>{children}</AlertContext.Provider>;
};

export default AlertProvider;
